import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const deleteVesselCostCentresQuery = (vesselCostCenterIds) => {
  return axios.post(apiurl?.deleteVesselCostCentre, { vesselCostCenterIds });
};

const deleteVesselCostCentres = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteVesselCostCentresQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getvesselcostcenterlist');
    }
  });
};

export default deleteVesselCostCentres;
